import { useEffect, useState } from 'react'
import { onToast, type ToastMessage } from '../lib/toast'

/** Renders showToast() calls. Deliberately looks like WeChat's own toast. */
export default function ToastHost() {
  const [message, setMessage] = useState<ToastMessage | null>(null)

  useEffect(() => onToast((next) => {
    setMessage(next)
    const timer = setTimeout(() => setMessage((m) => (m?.id === next.id ? null : m)), next.duration)
    return () => clearTimeout(timer)
  }), [])

  if (!message) return null
  return (
    <div className="pointer-events-none fixed inset-x-0 top-1/2 z-[200] flex -translate-y-1/2 justify-center px-8">
      <div className="max-w-[70%] rounded-md bg-black/85 px-4 py-3 text-center text-13 leading-snug text-ivory">
        {message.icon === 'success' ? <div className="mb-1 text-h2 text-gold">✓</div> : null}
        {message.title}
      </div>
    </div>
  )
}
